import axios from "axios";

interface GenomeResp {
   id: string;
   datatype: string;
   provider: string;
   metadata: string;
   imputationUrl: string;
   processingStatus: string;
   imputationPipeline: string;
   ask: boolean;
   hash: string;
}

export default class GenomeApi {
   public static readMyGenomes = async (): Promise<GenomeResp[]> => {
      const response = await axios.get("/genomes");

      return response.data;
   };
}
